import { h } from 'preact';
import { useContext } from 'preact/compat';
import { Theme } from '../lib/render';

const SocialShare = () => {
	const theme = useContext(Theme);

	const { social } = theme;
	const {
		twitter,
		facebook,
		mailto,
	} = social;

	return (
		<div className="ea-social-share">
			<div>
				<span className="social-tag">Share</span>
				<ul>
					{twitter && (
						<li className="social-sharing-item twitter">
							<a
								href={twitter}
								className="social-pop"
							>
								<span className="screen-reader-text">Share this page on Twitter</span>
								<svg aria-hidden="true" focusable="false" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1684 408q-67 98-162 167 1 14 1 42 0 130-38 259.5t-115.5 248.5-184.5 210.5-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5t-114-159.5q33 5 61 5 43 0 85-11-112-23-185.5-111.5t-73.5-205.5v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5t371.5 99.5q-8-38-8-74 0-134 94.5-228.5t228.5-94.5q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z" /></svg>
							</a>
						</li>
					)}
					{facebook && (
						<li className="social-sharing-item facebook">
							<a
								href={facebook}
								className="social-pop"
							>
								<span className="screen-reader-text">Share this page on Facebook</span>
								<svg aria-hidden="true" focusable="false" viewBox="0 0 11 19" xmlns="http://www.w3.org/2000/svg">
									<path d="M9.72243 10.375H7.08571V18.25H3.57008V10.375H0.722427V7.10547H3.57008V4.64453C3.57008 3.70703 3.74586 2.91016 4.09743 2.25391C4.44899 1.59766 4.94118 1.10547 5.57399 0.777344C6.23024 0.425781 6.98024 0.25 7.82399 0.25C8.19899 0.25 8.59743 0.273438 9.0193 0.320312C9.44118 0.34375 9.7693 0.378906 10.0037 0.425781L10.3552 0.460938V3.23828H8.94899C8.29274 3.23828 7.81227 3.41406 7.50758 3.76562C7.22633 4.09375 7.08571 4.50391 7.08571 4.99609V7.10547H10.2146L9.72243 10.375Z" />
								</svg>
							</a>
						</li>
					)}
					{mailto && (
						<li className="social-sharing-item email">
							<a
								href={mailto}
								className="social-pop"
							>
								<span className="screen-reader-text">Share this page via Email</span>
								<svg aria-hidden="true" focusable="false" viewBox="0 0 24 18" xmlns="http://www.w3.org/2000/svg">
									<path d="M23.0001 -1.13292e-06C23.1163 0.000771589 23.2311 0.0250957 23.3377 0.0715019C23.4443 0.117908 23.5403 0.185433 23.6201 0.269999C23.7316 0.357753 23.8231 0.468232 23.8886 0.594095C23.9542 0.719959 23.9921 0.858325 24.0001 0.999999V16.26C24.0161 16.3948 23.9947 16.5314 23.9382 16.6549C23.8818 16.7783 23.7925 16.8839 23.6801 16.96C23.6024 17.0478 23.5069 17.1182 23.4001 17.1664C23.2932 17.2147 23.1773 17.2398 23.0601 17.24H1.00005C0.880817 17.2492 0.761001 17.2325 0.648813 17.1911C0.536624 17.1496 0.434713 17.0845 0.350055 17C0.285508 16.9761 0.227456 16.9375 0.180564 16.8871C0.133672 16.8367 0.0992469 16.7761 0.080055 16.71C0.0257354 16.5662 -0.00139203 16.4137 5.49802e-05 16.26V0.999999C0.0042832 0.860644 0.0376043 0.723713 0.0978793 0.597997C0.158154 0.472281 0.244051 0.360557 0.350055 0.269999C0.433229 0.181697 0.534143 0.111991 0.646168 0.0654572C0.758194 0.0189235 0.878796 -0.00338431 1.00005 -1.13292e-06H23.0001ZM8.19005 8.77L1.87005 3.28V14.47L8.19005 8.77ZM20.5101 2.22H3.43006L11.9301 9.75L20.5101 2.22ZM14.3501 10L12.5601 11.68H11.3101L9.63006 10L3.63006 15.39H20.2801L14.3501 10ZM15.7601 8.79L22.1101 14.49V3.28L15.7601 8.79Z" />
								</svg>
							</a>
						</li>
					)}
				</ul>
			</div>
		</div>
	);
};

export default SocialShare;
